import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL


export const uploadKnowledgeCenterDocAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser")) 
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    
    const response = await axios.post(`${apiBaseUrl}/superAdmin/uploadKnowlegeCenterFile`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error adding profile photo:", error);
    throw error;
  }
}



export const getKnowledgeCenterDocAPI = async () => {
    try {
      const apiToken = JSON.parse(localStorage.getItem("authUser")) 
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      };
      
      const response = await axios.get(`${apiBaseUrl}/superAdmin/viewKnowlegeCenterFile`, {
        headers,
      });
  
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }



  export const rmKnowledgeCenterDocAPI = async formdata => {
    try {
      const apiToken = JSON.parse(localStorage.getItem("authUser")) 
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      };
      
      const response = await axios.post(`${apiBaseUrl}/superAdmin/deleteKnowlegeCenterFile`, formdata, {
        headers,
      });
  
      return response;
    } catch (error) {
      console.error("Error adding profile photo:", error);
      throw error;
    }
  }
